import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { reportsApi } from '../api/reports';

const KEYS = {
  list:   (page: number) => ['reports', 'list', page] as const,
  detail: (id: number)   => ['reports', 'detail', id] as const,
};

export function useReports(page = 1) {
  return useQuery({
    queryKey: KEYS.list(page),
    queryFn:  () => reportsApi.list(page),
    staleTime: 60_000,
  });
}

export function useReport(id: number) {
  return useQuery({
    queryKey: KEYS.detail(id),
    queryFn:  () => reportsApi.find(id),
    enabled:  id > 0,
  });
}

export function useGenerateReport() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (auditRunId?: number) => reportsApi.generate(auditRunId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['reports'] });
    },
  });
}

export function useDeleteReport() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: number) => reportsApi.destroy(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['reports'] });
    },
  });
}
